export const styles = () => ({
    currentCities: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    },
    column: {
        flexDirection: 'column'
    },
    othersCheckbox: {
        display: 'flex',
        alignItems: 'center'
    }
});
